const AiChatMessageStatus = {
  COMPLETED: 'COMPLETED',
  STOPPED  : 'STOPPED'
}

export default AiChatMessageStatus
